const { InspectorControls } = wp.blockEditor;
const { TextControl, ToggleControl, PanelBody, SelectControl } = wp.components;
import CommonPanel from '../wp-controlers/common-panel';

export default function Inspector({ attributes, setAttributes }) {
  const availableTabs = [
    { label: 'Internet em casa', value: 'internet_default' },
    { label: 'Internet + Streaming', value: 'internet_tv_combo' },
  ];

  return (
    <InspectorControls>
      <PanelBody title="Dados dos Planos" initialOpen={true}>
        <TextControl
          label="Título do Plano"
          value={attributes.plans_title}
          onChange={(value) => setAttributes({ plans_title: value })}
        />

        <SelectControl
          label="Tipo"
          value={attributes.plans_type}
          options={[
            { label: 'PF', value: 'PF' },
            { label: 'PJ_PME', value: 'PJ_PME' },
          ]}
          onChange={(value) => setAttributes({ plans_type: value })}
        />

        <TextControl
          label="Código Cidade"
          value={attributes.plans_city_code}
          onChange={(value) => setAttributes({ plans_city_code: value })}
        />

        <ToggleControl
          label={'Ativar sistema de guias'}
          help={
            attributes.per_tab
              ? 'Exibe o sistema para controle de guias do bloco'
              : 'Limita a exibição a uma guia, desativando o sistema de tabs para o bloco'
          }
          checked={attributes.per_tab}
          onChange={(per_tab) => setAttributes({ per_tab })}
        />

        {!attributes.per_tab && (
          <SelectControl
            label={'Guia a ser exibida'}
            value={attributes.tab_to_show}
            options={availableTabs}
            onChange={(tab_to_show) => setAttributes({ tab_to_show })}
          />
        )}
      </PanelBody>

      <CommonPanel attributes={attributes} setAttributes={setAttributes} />
    </InspectorControls>
  );
}
